import { addReportDays, toReportISODate } from './dateRangeUtils';

/** Matches server storeListPerformance.periodBounds() — last 30d through yesterday vs prior 30d. */
export function storeHubPeriodBounds() {
  const today = toReportISODate();
  const endDate = addReportDays(today, -1);
  const startDate = addReportDays(endDate, -29);
  const previousEnd = addReportDays(startDate, -1);
  const previousStart = addReportDays(previousEnd, -29);
  const fmt = (d) => {
    const ms = Date.parse(`${d}T12:00:00+05:30`);
    return new Date(ms).toLocaleDateString('en-IN', {
      timeZone: 'Asia/Kolkata',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };
  return {
    startDate,
    endDate,
    previousStart,
    previousEnd,
    label: `Last 30 days (${fmt(startDate)} – ${fmt(endDate)})`,
  };
}
